export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const directions = [
    'Лидерство', 'Влияние', 'Коммуникация',
    'Мотивация', 'Решения', 'Развитие команды',
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/c3ed4b28-230b-41c2-9e56-60e8209a360c_compressed_123.webp"
          alt="Тренинг по лидерству для руководителей"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-32 md:pt-24 pb-12 md:pb-16">
        <div className="max-w-3xl">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white mb-5 leading-tight">
            Тренинг по лидерству для руководителей
          </h1>
          <p className="text-sm md:text-lg text-white/85 mb-4 leading-relaxed max-w-xl">
            Как влиять на команду, развивать самостоятельность сотрудников и добиваться результата без постоянного контроля и давления.
          </p>
          <p className="text-sm text-white/60 mb-6">
            Корпоративная программа для руководителей и управленческих команд. Адаптируем содержание под задачи бизнеса, уровень участников и реальные управленческие ситуации.
          </p>

          <div className="flex flex-wrap gap-2 mb-8">
            {directions.map((dir) => (
              <span key={dir} className="bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 px-3 py-1.5 rounded-full text-xs font-medium">
                {dir}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => scrollTo('contact')}
              className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Заказать тренинг по лидерству
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollTo('contact')}
              className="border border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/10 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Обсудить задачу
              <i className="ri-chat-3-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}